<div class="flex">
  <div class="flex-col basis-full capability-details p-20">
    <div class="fixed-header">
      <div class="flex flex-row header justify-between">
        <div class="flex flex-col">
          <div class="fs-34 fw-600 max-limit-per-line">{{capability?.displayName ? (capability?.displayName) : ((capability?.name) ? (capability?.name) : 'INSTANCE_SUMMARY.SERVICE_DEFINITION.NOT_AVAILABLE' | transloco) }}</div>
          <div class="flex flex-row mt-10">
            <!-- <span class="flex fs-16 fw-400">{{'CAPABILITIES.VERSION' | transloco}}: {{version}}</span> -->
            <span class="flex release-version">
              <mat-icon svgIcon="error_outline" class="icon-sm mt-4 mr-6 fw-700"></mat-icon>
              {{('BLUEPRINT_SUMMARY.RELEASE' | transloco) + ' ' + (releaseVersion ? releaseVersion : 'N/A')}}
              <div *ngIf="isAMR" class="flex flex-row justify-center items-center amr-text ml-10">
                {{('BLUEPRINT_SUMMARY.AMR' | transloco)}}
                </div>
            </span>
          </div>
        </div>
        <mat-icon svgIcon="close" class="fs-32 cursor-pointer mt-12" (click)="matdialogRef.close()"></mat-icon>
      </div>
      <div class="flex flex-row basis-full body mt-32 documentationData">
        <div class="vertical-menu w-212 mr-24">
          <div *ngFor="let documentation of mockedDocumentationData" (click)="selectDocumentation(documentation)"
            class="menu-item" [ngClass]="{'selected': documentation.title === selectedDocumentation}">
            {{documentation.title}}
          </div>
        </div>
        <div class="flex basis-full description fs-16 fw-400" [innerHTML]="description"></div>
      </div>
    </div>
    <mat-divider class="w-100-percent mb-32"></mat-divider>
    <div class="flex flex-row justify-end">
      <button class="white blend-border" (click)="matdialogRef.close()">{{'BUTTONS.CANCEL' | transloco}}</button>
      <button *ngIf="selectable && !capabiltyDisabled" class="accent ml-16 blend-border" (click)="toggleSelection()"
      [ngClass]="{'disabled': !capability?.displayName && !capability?.name}">{{(capability.selected ? 'CAPABILITIES.REMOVE FROM YOUR SERVICE' : 'CAPABILITIES.ADD TO YOUR SERVICE') | transloco}}</button>
    </div>
  </div>
</div>


